import { httpGet, httpPost } from "../http"

export interface V1CustomerPaymentOptionsBody {
  is_access_token_new: number
  context_id: string
  service: string
}

export interface V1CustomerPaymentOptionsResponse {
  flag: number
  data: PaymentOption[]
  pin: Pin
}

interface Pin {
  need_warning: boolean
  message: string
  action_title: string
}

export interface PaymentOption {
  "@type": string
  display_name: string
  type: string
  payment_method?: number
  image?: string
  sub_title?: string
  balance?: string
  is_action?: boolean
  payment_flow?: number
  internal_msg?: string
  cards_data?: Cardsdata
  scheme?: string
  business_id?: string
  external_id?: string
  bank_data?: Bankdata
  is_linked?: boolean
  e_wallet_data?: Ewalletdata
  toast_msg?: string
  data?: PaymentOptionItem[]
}

export interface Cardsdata {
  id: string
  last_4: string
  exp_month: string
  exp_year: string
  brand: string
  image: string
}

interface PaymentOptionItem {
  payment_method: number
  image: string
  display_name: string
  type: string
}

interface Ewalletdata {
  id: string
  phone: string
  scheme: string
  image: string
}

interface Bankdata {
  id: string
  account: string
  code: string
  image: string
}

export function v1CustomerPaymentOptions(
  body: V1CustomerPaymentOptionsBody
): Promise<{ data: V1CustomerPaymentOptionsResponse }> {
  return httpPost("be-user-payment/customer/payment_options", body)
}

export interface V1PaymentRequestAddCardBody {
  scheme: string
  service: string
  payment_method: number
}

export interface V1PaymentRequestAddCardResponse {
  flag: number
  message: string
  html: string
}

export async function v1PaymentRequestAddCard(
  body: V1PaymentRequestAddCardBody
): Promise<{ data: V1PaymentRequestAddCardResponse }> {
  return httpPost("be-user-payment/customer/request_add_card", body)
}

export interface V1LinkEWalletBody {
  funding: string
  payment_method: number
}

export interface V1LinkEWalletResponse {
  flag: number
  scheme: string
  linkageUrl: string
  packageId: string
  message: string
  apiId: number
  bindingToken: string
}

export function v1LinkEWallet(
  body: V1LinkEWalletBody
): Promise<{ data: V1LinkEWalletResponse }> {
  return httpPost("be-user-payment/customer/link_ewallet", body)
}

export interface V1LinkAccountWebformBody {
  payment_method: number
}

export interface V1LinkAccountWebformResponse {
  flag: number
  message: string
  linkageUrl: string
  html: string
}

export function v1LinkAccountWebform(
  body: V1LinkAccountWebformBody
): Promise<{ data: V1LinkAccountWebformResponse }> {
  return httpPost("be-user-payment/customer/link_account_web_form", body)
}

export interface V1CustomerPaymentStaticConfigResponse {
  flag: number
  message: string
  data: StaticConfigItem[]
}

export interface StaticConfigItem {
  key: string
  dict: StaticConfigDict[]
}

export interface StaticConfigDict {
  payment_method: number
  value: string
}

export function v1CustomerPaymentStaticConfig(): Promise<{
  data: V1CustomerPaymentStaticConfigResponse
}> {
  return httpGet(
    "be-user-payment/customer/data/static_config",
    undefined as any
  )
}

export interface CustomerPaymentMetrixBody {
  service: string
  type: number
  source?: number
  payment_methods?: number[]
}

export interface V1CustomerPaymentMatrixResponse {
  flag: number
  data: MatrixItem[]
}

export interface MatrixItem {
  "@type": string
  display_name: string
  type: string
  banner?: any[]
  payment_method: number
  image: string
  sub_title?: string
  balance?: string
  is_action?: boolean
  payment_flow?: number
  internal_msg?: string
  status?: number
}

export function v1CustomerPaymentMetrix(
  body: CustomerPaymentMetrixBody
): Promise<V1CustomerPaymentMatrixResponse> {
  return httpPost("be-user-payment/customer/display_payment_matrix", body).then(
    (resp) => resp.data
  )
}
